<template>
  <div class="ppe-applied-check">
    <div class="el-input-group el-input-group--append el-input-group--prepend">
      <div v-if="nonComponentWarnings.length" class="el-input-group__prepend">
        <help-tooltip type="warning">
          <span v-for="warning in nonComponentWarnings" :key="warning.message">
            {{ warning.message }}
            <br>
          </span>
        </help-tooltip>
      </div>
      <el-select
        v-close-on-zoom
        :value="state.check.isCurrent"
        :disabled="readonly"
        @input="isCurrent => updateCurrent(isCurrent)"
      >
        <el-option :value="false" :label="'Was PPE applied'" />
        <el-option :value="true" :label="'Is PPE applied'" />
      </el-select>
    </div>

    <div class="el-input-group el-input-group--append el-input-group--prepend">
      <div v-if="componentWarnings.length" class="el-input-group__prepend">
        <help-tooltip v-if="componentWarnings.length" type="warning">
          <span v-for="warning in componentWarnings" :key="warning.message">
            {{ warning.message }}
            <br>
          </span>
        </help-tooltip>
      </div>
      <el-select
        v-close-on-zoom
        :value="state.check.ids"
        placeholder="any ppe"
        multiple
        class="ppe-select"
        :disabled="readonly"
        @input="ids => updatePPE(ids)"
      >
        <el-option
          v-for="item in availablePPE"
          :key="item.key"
          :label="item.label.en"
          :value="item.key"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import { debounce, get, uniqBy } from 'lodash';

import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'ppe-check',
  components: {
    HelpTooltip,
  },
  props: [
    'treatments',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        check: {
          ids: [],
          isCurrent: false,
        },
      },
    };
  },
  computed: {
    availablePPE() {
      const { isGlobal } = this.emitter;
      if (isGlobal) {
        return this.ppeTreatment.components;
      }
      const ppe = this.emitter.caseConf._treatments.find(t => t.id === 'PERSONAL_PROTECTIVE_EQUIPMENT');
      const options = get(ppe, 'options.componentOptions', {});
      return this.ppeTreatment.components.filter(c => options[c.key] && options[c.key].toggled);
    },
    ppeTreatment() {
      return this.treatments.find(t => t.id === 'PERSONAL_PROTECTIVE_EQUIPMENT');
    },
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      const warnings = get(
        this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(warning => warning.metadata && warning.metadata.checkKey === this.ikey);

      return uniqBy(warnings, 'message');
    },
    componentWarnings() {
      return this.warnings.filter(warning => warning.metadata.componentId);
    },
    nonComponentWarnings() {
      return this.warnings.filter(warning => !warning.metadata.componentId);
    },
  },
  beforeMount() {
    this.state.check = { ...this.state.check, ...this.getData(this.ikey) };
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    updatePPE(ids) {
      this.state.check.ids = ids;
      this.update();
    },
    updateCurrent(isCurrent) {
      this.state.check.isCurrent = isCurrent;
      this.update();
    },
    update: debounce(function update() {
      this.putData(this.ikey, {
        type: 'PERSONAL_PROTECTIVE_EQUIPMENT',
        id: 'PERSONAL_PROTECTIVE_EQUIPMENT',
        operator: 'EQUAL',
        value: true,
        ...this.state.check,
      });
      this.emitter.trigger('process', this.control);
    }),
  },
};
</script>

<style scoped>
.ppe-applied-check {
  width: 100%;
  display: flex;
  align-items: flex-start;
}
.ppe-applied-check > div {
  width: 50%;
}

.el-select {
  flex: 1;
  width: 100%;
}
.el-input {
  flex: 1;
}
</style>
